<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="gewinnermittlungsart">{{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.GEWINNERMITTLUNGSART.TITEL' | translate }}
    </label>
    <div class="col-sm-8">
      <select class="form-control" datevMessagePath="gewinnermittlungsart{{objectId}}" formControlName="gewinnermittlungsart" id="gewinnermittlungsart"
              utilsCheckValidity utilsControlState
              utilsMarkRequired utilsValidationMessage>
        <option [ngValue]="null" disabled hidden
                selected>{{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.GEWINNERMITTLUNGSART.NULL' | translate }}</option>
        <option *ngFor="let value of enumKeys(gewinnermittlungsartEnum)"
                [ngValue]="gewinnermittlungsartEnum[value]">
          {{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.GEWINNERMITTLUNGSART.KEY_' + gewinnermittlungsartEnum[value] | translate }}
        </option>
      </select>
    </div>
  </div>

  <div *ngIf="data.gewinnermittlungsart === gewinnermittlungsartEnum._04" class="form-row">
    <label class="col-sm-4 col-form-label" for="erlaeuterungSonstigeGewinnermittlungsart">
      {{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.ERLAEUTERUNG_SONSTIGE' | translate }}
    </label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="erlaeuterungSonstigeGewinnermittlungsart{{objectId}}" formControlName="erlaeuterungSonstigeGewinnermittlungsart" id="erlaeuterungSonstigeGewinnermittlungsart"
             type="text" utilsCheckValidity
             utilsControlState utilsMarkRequired utilsValidationMessage/>
    </div>
  </div>

  <div *ngIf="showArtAufteilung" class="form-row">
    <label class="col-sm-4 col-form-label"
           for="artAufteilung">{{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.ART_AUFTEILUNG.TITEL' | translate }}
    </label>
    <div class="col-sm-8">
      <select class="form-control" datevMessagePath="artAufteilung{{objectId}}" formControlName="artAufteilung"
              id="artAufteilung"
              utilsCheckValidity utilsControlState
              utilsMarkRequired utilsValidationMessage>
        <option [ngValue]="null" disabled hidden
                selected>{{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.ART_AUFTEILUNG.NULL' | translate }}</option>
        <option *ngFor="let value of enumKeys(artAufteilungEnum)"
                [ngValue]="artAufteilungEnum[value]">
          {{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.ART_AUFTEILUNG.KEY_' + artAufteilungEnum[value] | translate }}
        </option>
      </select>
    </div>
  </div>

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="abweichendesWirtschaftsjahr">{{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.ABWEICHENDES_WJ.TITEL' | translate }}
    </label>
    <div class="col-sm-8">
      <select class="form-control" datevMessagePath="abweichendesWirtschaftsjahr{{objectId}}" formControlName="abweichendesWirtschaftsjahr"
              id="abweichendesWirtschaftsjahr" (change)="onAbweichendesWirtschaftsJahrChanged()"
              utilsCheckValidity utilsControlState
              utilsValidationMessage>
        <option [ngValue]="null" disabled hidden
                selected>{{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.ABWEICHENDES_WJ.NULL' | translate }}</option>
        <option [ngValue]="true"
        >{{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.ABWEICHENDES_WJ.JA' | translate }}</option>
        <option [ngValue]="false"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.ABWEICHENDES_WJ.NEIN' | translate }}</option>
      </select>
    </div>
  </div>

  <div *ngIf="data.abweichendesWirtschaftsjahr" class="form-row">
    <label class="col-sm-4 col-form-label" for="beginnAbweichendesWirtschaftsjahr">
      {{ 'COMMON_UI.FRAGEBOGEN.GEWINNERMITTLUNG.ABWEICHENDES_WJ.BEGINN' | translate }}
    </label>
    <div class="col-sm-8">
      <date-picker
              id="beginnAbweichendesWirtschaftsjahr"
              messagePath="beginnAbweichendesWirtschaftsjahr"
              formControlName="beginnAbweichendesWirtschaftsjahr"
              [isRequired]=false>
      </date-picker>
    </div>
  </div>

</form>
